import {
    UPDATE_COLOR_PALETTE,
    UPDATE_COLOR_SUCCEEDED,
    UPDATE_COLOR_FAILED

  } from "constants/actionTypes.jsx";
  
  import axios from "axios";
  import buildUrl from "build-url";
  import { createAction } from "redux-actions";
  import { call, put, takeLatest } from "redux-saga/effects";
  
  const API_URL = process.env.REACT_APP_API_URL;
  const COLOR_BASE_URL = `${API_URL}/api/1.0/accounts`;
  
  /** update color palette */
  export const updateColor = createAction(UPDATE_COLOR_PALETTE);
  const updateColorSucceeded = createAction(UPDATE_COLOR_SUCCEEDED);
  const updateColorFailed = createAction(UPDATE_COLOR_FAILED);
  
  function* updateColorCustomization(action) {
  const colorPaletteRequest= action.payload.initialColorPalette;
  const id =action.payload.id;

  

  let url = buildUrl(`${COLOR_BASE_URL}/${id}/brand-theme`);
    const updateColorAPI = () => {
      return axios({
        method: "PUT",
        url: url,
        data: colorPaletteRequest
       
      }).then((response) => response.data);
      
    };
    
    try {
      const response = yield call(updateColorAPI);
      yield put(updateColorSucceeded(response));
    } catch (error) {
      yield put(updateColorFailed(error));
    }
  }
  
  export default function* colorpalette() {
    yield takeLatest(UPDATE_COLOR_PALETTE, updateColorCustomization);
  }
  